import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

// project-imports
// types
import { GuardProps } from 'types/UsuarioSM';
// ==============================|| AUTH GUARD ||============================== //
const AuthGuard = ({ children }: GuardProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const userLog = useSelector((state: any) => state.User);
  useEffect(() => {
    if (false) { //if (!userLog.Logeado) {
      navigate('/', {
        state: {
          from: location.pathname
        },
        replace: true
      });
    }
  }, [userLog, navigate, location]);

  return children;
};

export default AuthGuard;
